export const prosemirrorPaddingStyles = `
    padding: 8px 16px;
`;